import './CustomPaginationLink.style';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Link from 'Component/Link';

export default class CustomPaginationLink extends PureComponent {
    static propTypes = {
        text: PropTypes.string.isRequired,
        getPage: PropTypes.func.isRequired,
        label: PropTypes.string.isRequired,
        isCurrent: PropTypes.bool.isRequired,
        pageNumber: PropTypes.number.isRequired,
    };

    getPage = () => {
        const { getPage, pageNumber } = this.props;
        getPage(pageNumber);
    };

    render() {
        const {
            text,
            label,
            isCurrent
        } = this.props;

        return (
            <Link
              to=''
              aria-label={ label }
              block="CustomPaginationLink"
              mods={ { isCurrent } }
              aria-current={ isCurrent ? 'page' : 'false' }
              onClick={ this.getPage }
            >
                { text }
            </Link>
        );
    }
}
